import {Link} from 'react-router-dom';
import styled from 'styled-components';

const CustomLink = styled(Link)`
  text-decoration: none;
`;

export default CustomLink;
